import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7db5c7c3"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "menu" };
const _hoisted_2 = {
    key: 0,
    class: "responsive_menu_content"
};
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "close-cont" };
import Menus from '@/components/organisms/header/Menus.vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useStore } from '@/store/store';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const isShowMenu = ref(false);
        const showMenu = () => {
            isShowMenu.value = true;
        };
        const hideMenu = () => {
            isShowMenu.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Menus, {
                        "is-auth": props.isAuth
                    }, null, 8, ["is-auth"])
                ]),
                _createVNode(MaterialIcon, {
                    name: _unref(store).state.isSmartPhone ? 'menu' : 'wallet',
                    class: "responsive_menu_button",
                    onClick: showMenu
                }, null, 8, ["name"]),
                (isShowMenu.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(MaterialIcon, {
                                    name: "close",
                                    class: "close",
                                    onClick: hideMenu
                                })
                            ]),
                            _createVNode(Menus, {
                                "is-auth": props.isAuth,
                                class: "responsive_menus",
                                onLanguageClick: hideMenu
                            }, null, 8, ["is-auth"])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
